import React from 'react';
import './chapters.scss';
import Videos from '../Videos/Videos';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter7() {
  const hyperlinkData = [
    {
      origin: 'redbox',
      href: 'https://www.spravato.com/spravato-patient-stories?utm_source=CNN&utm_medium=Article&utm_campaign=SPR_SponCon&utm_id=Patient_Article',
      a: 'SPRAVATO.com'
    },
    {
      origin: 'redbox',
      href: 'https://www.sharemyjanssenstory.com/?utm_source=CNN&utm_medium=Article&utm_campaign=SPR_SponCon&utm_id=Patient_Article',
      a: 'SHARE Network'
    }
  ];
  return (
    <div className="chapters__chapter">
      <h3>Fostering a Sense of Hope for Others</h3>
      <p className="chapters__chapter__paragraph">
        Grace wants to emphasize to people struggling with treatment-resistant depression a
        realization that was crucial for her recovery: “Let go of these ideas of depression being
        linked with laziness or a lack of motivation. It's not a failure on the part of someone who
        is struggling. If you’re taking medication and it’s not working, you haven’t failed — the
        medication has failed you.”
      </p>
      <p className="chapters__chapter__paragraph">
        For Ben, the key is being honest with yourself. “You need to accept that you need help. I
        delayed that for years and years.”
      </p>
      <p className="chapters__chapter__paragraph">
        Finally, Allison has a special message for caregivers: “You’re your child's biggest
        advocate, but you have to take care of yourself, too, so you can be strong. I encourage
        anybody that's starting this journey to have a lot of grace with themselves.”
      </p>
      <Videos />
      <div className="chapters__chapter__infobox chapters__chapter__infobox--red">
        <p>
          If you or someone you know has been experiencing severe depressive symptoms with TRD, talk
          to a healthcare provider about SPRAVATO® and whether it may be the right fit. 
        </p>
        <p>
          You can also visit <Hyperlink hyperlinkData={hyperlinkData[0]} /> to learn more and hear
          other people’s experiences with the medication.
        </p>
        <p className="chapters__chapter__infobox--italic">
          If a Johnson & Johnson treatment has made a difference in your life or the life of a loved
          one, we hope you will consider joining the <Hyperlink hyperlinkData={hyperlinkData[1]} />.
        </p>
      </div>
    </div>
  );
}

export default Chapter7;
